import classNames from 'classnames'
import { useFormContext } from 'react-hook-form'

import { InputInfoSM } from '@apps-common/components/elements'
import { commonIcons } from '@apps-common/config/icons'
import { IActivationServiceRequestCreateModel } from '@apps-common/types/portal/service-request'
import { IUnitPlanModel } from '@apps-common/types/portal/unit'
import { UnitActivationPlanCardSkeleton } from '../UnitActivationPlanCard'

interface IProps {
  loading?: boolean
  updating?: boolean
  templatePlanId?: string
  plan?: IUnitPlanModel
}

export const ActivationPlanView: React.FC<IProps> = ({ loading, updating, templatePlanId, plan }) => {
  const { getValues } = useFormContext<IActivationServiceRequestCreateModel>()

  const { unitPlanId } = getValues()

  return (
    <InputInfoSM
      id='plan'
      hideNoEditIcon
      showLabel
      label='Plan'
      value={
        <>
          {loading && (
            <div className='relative rounded-3xl px-4 py-4 text-left bg-surface-2 border border-border flex'>
              <UnitActivationPlanCardSkeleton />
            </div>
          )}
          {!loading && (
            <div className='relative rounded-3xl px-4 py-4 text-left bg-surface-2 border border-border flex'>
              <div className='bg-surface rounded-3xl px-3 py-3 border border-border min-w-[170px]'>
                {templatePlanId && templatePlanId !== unitPlanId && (
                  <div className='flex items-center justify-center mb-[10px]'>
                    <div className='!text-[0.8rem] leading-[1.1rem] pl-[5px] pr-[10px] py-[5px] rounded-full flex items-center justify-center gap-[7px] jost bg-warning/40 text-on-warning ring-1 ring-warning'>
                      <div className='p-2 rounded-full bg-warning'>
                        <commonIcons.warning className='text-[1.4rem] mb-[2px]' />
                      </div>
                      <div>The selected inactive device has a fixed plan and cannot be changed.</div>
                    </div>
                  </div>
                )}
                <div className='p-2 text-[0.9rem]'>
                  <div className='mb-[8px] jost text-[0.8rem]'>{plan?.unitPlanName}</div>
                  <div className='flex flex-col gap-[3px] text-text'>
                    {plan?.planDescription?.split(',')?.map((d, di) => (
                      <div
                        key={`unit-plan-description-item-${plan.unitPlanId}-${di}`}
                        className='text-[0.85em] flex items-center justify-between'
                      >
                        {d?.split(':')?.map((dv, dvi) => (
                          <div
                            key={`unit-plan-description-item-${plan.unitPlanId}-${di}-${dvi}`}
                            className={classNames(dvi % 2 === 0 && 'jost-light bg-surface-2 rounded-[3px] px-[3px]')}
                          >
                            {dv}
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      }
      className={classNames('border-none !p-0 !opacity-100', loading && 'min-h-[125px]')}
    />
  )
}
